// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TvIa","name":"Header_name__1xGR-","birthday":"Header_birthday__1VNlb","skeleton":"Header_skeleton__lve5U"};